import React, { Component } from "react";
import FlexView from "react-flexview";
import {
  getConfigYearToDate,
  getConfigYearToDateSA,
  yearOptions,
  transformResponseYTDMechanic,
  transformResponseYTDSA,
} from "../config";
import { removeNullFields } from "../../../../../common/mapper";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { HttpStatus } from "../../../../../common/Constants";
import { saveAs } from "file-saver";
import { buildExcelRequestBodyJualPartYTD } from "../configExcel";

class LaporanYTDPart extends Component {
  constructor(props) {
    super(props);
    const currentYear = new Date().getFullYear();
    this.state = {
      year: null,
      tableConfig: getConfigYearToDate("MECHANIC", currentYear),
      tableConfigSA: getConfigYearToDateSA(currentYear),
      dataTable: [],
      dataTableSA: [],
    };
  }

  componentDidMount() {
    let currentDate = new Date();
    this.setState((prevValue) => ({
      ...prevValue,
      year: yearOptions.find(
        (item) => item.value === currentDate.getFullYear(),
      ),
    }));
  }

  compareObject = (data1, data2) => {
    return JSON.stringify(data1) === JSON.stringify(data2);
  };

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleSearch = () => {
    this.fetchData();
  };

  fetchData = async () => {
    const userId = localStorage.getItem("userId");

    try {
      this.props.triggerLoading();
      const request = removeNullFields({
        kodeCabang: this.props.search.selectedCabang,
        year: this.state.year.value,
        idUser: userId,
        type: "MECHANICSA",
      });

      const res = await fetchDataAsync({
        asyncFn:
          Api.create("NAGAMAS_REPORT_DTO").getLaporanJualPartYTDByMechanicH23,
        setError: this.props.setError,
        menuName:
          "Dashboard Level Mekanik dan SA - Laporan Jual Part Year To Date",
        args: request,
      });

      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        const { mechanic, sa } = res.data.data;

        this.setState({
          dataTable: transformResponseYTDMechanic(mechanic),
          dataTableSA: transformResponseYTDSA(sa),
          tableConfig: getConfigYearToDate("MECHANIC", this.state.year.value),
          tableConfigSA: getConfigYearToDateSA(this.state.year.value),
        });
      }
      this.props.triggerLoading();
    } catch (error) {
      this.props.triggerLoading();
      console.log("errors: ", error);
    }
  };

  handlePrint = async () => {
    const { month, year, dataTable, dataTableSA } = this.state;
    this.props.triggerLoading();

    try {
      const reqBody = buildExcelRequestBodyJualPartYTD({
        year,
        dataTable,
        dataTableSA,
      });

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
        menuName:
          "Dashboard Level Mekanik dan SA - Laporan Jual Part YTD",
        setError: this.props.setError,
        args: reqBody,
      });

      if (res?.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, `${reqBody.filename}.xlsx`);
      }
    } catch (error) {
      console.error("Error saat generate Excel:", error);
      this.props.setError("Gagal generate file Excel");
    } finally {
      this.props.triggerLoading();
    }
  };

  render() {
    let { dataTable, dataTableSA } = this.state;
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={this.handleSearch}
          >
            Cari
          </SimpleButton>
        </FlexView>
        <div style={{ marginBottom: "30px" }}>
          {/* {dataTable.length > 0 && ( */}
          <SimpleDataTable
            data={this.state.dataTable}
            columns={this.state.tableConfig}
            options={{ pagination: false }}
          />
          {/* )} */}
        </div>

        {/* {dataTableSA.length > 0 && ( */}
        <SimpleDataTable
          data={this.state.dataTableSA}
          columns={this.state.tableConfigSA}
          options={{ pagination: false }}
        />
        {/* )} */}

        <FlexView hAlignContent="right" className="margin-top-20px">
          <SimpleButton
            id="btn_print"
            text="CETAK"
            onClick={() => this.handlePrint()}
          />
        </FlexView>
      </>
    );
  }
}

export default LaporanYTDPart;
